import { isBrowser, isLocalhost, isProductionMode } from '@/utils/environmentUtils'

export async function initDev() {
  if (!isProductionMode && isBrowser && !isLocalhost) {
    const vConsole = await import(/* webpackChunkName: "vconsole" */ 'vconsole')

    new vConsole.default()
  }
}
